//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.OperationBuilder.js";
import "../CAM/CAM.InspectionFeatureDataFilterBuilder.js";
import "../no/SelectNXObject.js";
import "../no/SelectObject.js";
let d=[[[0,"AxisDirectionI",1,0],[0,"AxisDirectionJ",1,0],[0,"AxisDirectionK",1,0],[0,"CenterPointX",1,0],[0,"CenterPointY",1,0],[0,"CenterPointZ",1,0],[0,"CsysReferenceType",1,0],[1,"DataFilterBuilder",0,"CAM.InspectionFeatureDataFilterBuilder",0],[0,"InnerOuterType",1,0],[0,"MajorRadius",1,0],[0,"MinorRadius",1,0],[0,"Name",1,0],[0,"ReverseDirection",1,0],[1,"SelectedTorus",0,"SelectNXObject",0]],[[[],"UpdateParams",{},0,0],[[],"FlipAxisDirection",{},0,0]],[]];
SPLM.CAM.InspectionTorusFeatureBuilder = class extends SPLM.CAM.OperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionTorusFeatureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;